import type { GetScheduleItemsFilter } from '../types/scheduleItem.types';



/** Normalize API / form values to YYYY-MM-DD for comparisons and display. */

export function toDateOnlyString(

  value: string | Date | null | undefined,

): string | undefined {

  if (!value) return undefined;



  if (value instanceof Date) {

    if (isNaN(value.getTime())) return undefined;

    const year = value.getFullYear();

    const month = String(value.getMonth() + 1).padStart(2, '0');

    const day = String(value.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;

  }



  const trimmed = value.trim();

  if (!trimmed) return undefined;



  const isoMatch = trimmed.match(/^(\d{4}-\d{2}-\d{2})/);

  if (isoMatch) return isoMatch[1];



  const parsed = new Date(trimmed);

  if (!isNaN(parsed.getTime())) {

    return toDateOnlyString(parsed);

  }



  return undefined;

}



/** Format a WO pickup/delivery value for tooltip display (e.g. "Jul 20, 2026"). */

export function formatWoDateForDisplay(

  value: string | Date | null | undefined,

): string | undefined {

  const dateOnly = toDateOnlyString(value);

  if (!dateOnly) return undefined;

  const parsed = new Date(`${dateOnly}T00:00:00`);

  if (isNaN(parsed.getTime())) return dateOnly;

  return parsed.toLocaleDateString('en-US', {

    month: 'short',

    day: 'numeric',

    year: 'numeric',

  });

}



/** Build GetScheduleItems API payload (date-range mode only). */

export function buildScheduleItemsRequestBody(

  filter: GetScheduleItemsFilter,

): Record<string, unknown> {

  const body: Record<string, unknown> = {};



  if (filter.locationId != null) {

    body.locationId = filter.locationId;

  }

  if (filter.customerId != null) {

    body.customerId = filter.customerId;

  }

  if (filter.createdBy != null) {

    body.createdBy = filter.createdBy;

  }

  if (filter.statuses?.length) {

    body.statuses = filter.statuses;

  }

  if (filter.startDate) body.startDate = filter.startDate;

  if (filter.endDate) body.endDate = filter.endDate;



  return body;

}



export function normalizeScheduleItemsFilter(

  filter: GetScheduleItemsFilter,

): GetScheduleItemsFilter {

  return {

    startDate: filter.startDate,

    endDate: filter.endDate,

    locationId: filter.locationId,

    customerId: filter.customerId,

    createdBy: filter.createdBy,

    statuses: filter.statuses,

  };

}


